/**
 * Site-wide content protection:
 * - blocks right-click / context menu
 * - blocks copy / cut
 * - blocks image drag & save shortcuts
 * Form fields remain usable.
 */
(function () {
  if (window.Shopify && window.Shopify.designMode) return;

  const isEditable = (el) => {
    if (!el || !(el instanceof Element)) return false;
    const node = el.closest('input, textarea, select, [contenteditable="true"], [contenteditable=""], .no-content-protect');
    return Boolean(node);
  };

  const blockEvent = (event) => {
    if (isEditable(event.target)) return;
    event.preventDefault();
    event.stopPropagation();
    return false;
  };

  document.addEventListener('contextmenu', blockEvent, true);
  document.addEventListener('copy', blockEvent, true);
  document.addEventListener('cut', blockEvent, true);
  document.addEventListener('dragstart', (event) => {
    if (event.target && event.target.closest && event.target.closest('img, a, picture, svg')) {
      if (isEditable(event.target)) return;
      event.preventDefault();
    }
  }, true);

  document.addEventListener(
    'keydown',
    (event) => {
      if (isEditable(event.target)) return;

      const key = (event.key || '').toLowerCase();
      const withMod = event.ctrlKey || event.metaKey;

      // Block copy / cut / save / select-all / view-source / print
      if (
        withMod &&
        (key === 'c' ||
          key === 'x' ||
          key === 's' ||
          key === 'a' ||
          key === 'u' ||
          key === 'p')
      ) {
        event.preventDefault();
        return false;
      }

      // Block common DevTools shortcuts
      if (
        key === 'f12' ||
        (withMod && event.shiftKey && (key === 'i' || key === 'j' || key === 'c'))
      ) {
        event.preventDefault();
        return false;
      }
    },
    true
  );
})();
